import { useEffect, useState } from 'react';
import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography,Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag } from '../../../../../components';
import { getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';




const initialRadiologyAuhtorityDoctorDataObj = {
    data: [],
    loading: false
};

const TABLE_COLUMNS = [
    {
        header: 'Doctor Name',
        accessor: (row) => {
            const status = row.status;
            return (
                <span
                    style={{
                        color: status === 'inactive' ? 'red' : 'black',
                    }}
                >
                    {`${row.doctor}`}
                </span>
            );
        },
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: 'uppercase' }
    },
    {
        header: 'Created At',
        accessor: 'createdAt'
    }
];

export const RadiologyAuthorityDoctorMaster = () => {
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [radiologyauthoritydoctorDataObj, setRadiologyauthoritydoctorDataObj] = useState(initialRadiologyAuhtorityDoctorDataObj);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();


    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                doctor: Yup.string().required('Doctor Name  Is Required ')
            })
        ),
        mode: 'all'
    });
    const { handleSubmit, setValue, reset } = methods;

    useEffect(() => {
        if (selectedRecord) {
            const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', '__v', 'status', 'createdAt', 'beds']);
            keyValuePair.forEach(({ key, value }) => setValue(key, value));
        } else {
            reset();
        }
    }, [setValue, reset, selectedRecord]);

    const formSubmit = async (formValues) => {
        setLoading(true);
        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }
        const response = await request(editFlag ? '/radiology-authority-doctor-update' : '/radiology-authority-doctor-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: formValues
        });
        if (response?.success) {
            toast(`Successfully ${editFlag ? 'updated' : 'created'} Radiology Authority Doctor Master`, { variant: 'success' });
            setSelectedRecord(response.data);
            setCurrentAction();
            reset();
        } else {
            toast(`Failed to ${editFlag ? 'update' : 'create'} Radiology Authority Doctor Master`, {
                variant: 'error'
            });
        }
        setLoading(false);
    };

    const handlecancelRecord = async () => {
        setLoading(true);
        const response = await request('/radiology-authority-doctor-cancel', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully cancelled Radiology Authority Doctor Master', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to cancelled Radiology Auhtority Doctor Master ', { variant: 'error' });
        }
        setLoading(false);
    };


    const handleDeleteRecord = async () => {
        setLoading(true);
        const response = await request('/radiology-authority-doctor-delete', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully deleted Radiology Authority Doctor Master', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to delete Radiology Auhtority Doctor Master ', { variant: 'error' });
        }
        setLoading(false);
    };


    const handleQueryWindow = async () => {
        setOpenQueryDialog(true);
        setRadiologyauthoritydoctorDataObj({ loading: true });
        const response = await request('/radiology-authority-doctor-list', { method: 'GET' });
        if (response.success) {
            const filteredData = response.data.filter(item =>
                item.status === 'active' || item.status === 'inactive' || item.status === 'default'
            );
            setRadiologyauthoritydoctorDataObj({ loading: false, data: filteredData });
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setRadiologyauthoritydoctorDataObj({ loading: false });
        }
    };

    return (
        <>
            <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                                Authorised Doctor
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={`${lastPathSegment}Write`}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                    }}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                    onClick={handleSubmit(formSubmit)}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                        handlecancelRecord()
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                    onClick={handleDeleteRecord}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    onClick={handleQueryWindow}
                                    disabled={['new', 'edit'].includes(currentAction)}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: "1.4rem" }}>Doctor </Typography>
                                    <TextField
                                        disabled={!['new', 'edit'].includes(currentAction)}
                                        sx={{ flex: 0.8 }}
                                        placeholder="Enter Doctor Name"
                                        name="doctor"
                                    />
                                </Stack>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: "1.4rem" }}>Heading1</Typography>
                                    <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.8 }} name="heading_1" />
                                </Stack>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: "1.4rem" }}>Heading2</Typography>
                                    <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.8 }} name="heading_2" />
                                </Stack>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: "1.4rem" }}>Heading3</Typography>
                                    <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.8 }} name="heading_3" />
                                </Stack>
                            </Grid>
                        </Grid>
                        </Box>
                    </FormProvider>
                </Container>
            </Paper>
            <Dialog
                open={openQueryDialog}
                onClose={() => setOpenQueryDialog(false)}
                PaperProps={{ sx: { width: '80%', p: 1.5 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0.2}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        Radiology Authority Doctor Master Query Window
                    </Typography>
                    <IconButton onClick={() => setOpenQueryDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Table
                    sx={{ mt: 0.5 }}
                    columns={TABLE_COLUMNS}
                    data={radiologyauthoritydoctorDataObj.data || []}
                    loading={radiologyauthoritydoctorDataObj.loading}
                    onRowClick={(row) => {
                        setOpenQueryDialog(false);
                        setSelectedRecord(row);
                    }}
                />
            </Dialog>
        </>
    );
};
